<style lang="scss">
img {
    vertical-align: middle;
    height: 16px;
}
.logistics-title {
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #2db7f5;
    color: #fff;
}
</style>

<template>
    <div class="bg-fff shadow margin-top-20">
        <header class="logistics-title font-bold">
            {{
                $t("erp.b2c.logistics_information", {
                    defaultValue: "仓库物流信息",
                })
            }}
        </header>
        <Alert
            v-show="comLogistics.isChannelPay == 1"
            class="margin-left-20 margin-right-20 font-bold"
            type="error"
            >{{
                $t("erp.b2c.logistics_tip", {
                    defaultValue:
                        "小贴士：本订单运费由平台支付，请使用Third Party来打印面单！",
                })
            }}
            <span
                v-if="this.b2cOrderAccount"
                v-show="
                    comLogistics.accountRemark != '' &&
                    comLogistics.accountRemark != null
                "
                style="color: red"
                >({{ comLogistics.accountRemark }})</span
            ></Alert
        >
        <Form :label-width="120" :model="formData" class="margin-15 clearfix">
            <Col span="24">
                <Col span="12" style="height: 32px">
                    <FormItem
                        :label="
                            $t('erp.b2c.search_outwarehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                        v-if="alltype == 'query'"
                    >
                        <span class="font-weight">{{
                            this.findRenderLabel(
                                this.getWarehouseList,
                                comLogistics.orgWarehouseId
                            ) || "--"
                        }}</span>
                        <!-- <span>{{comLogistics.orgWarehouseId | transferText('title',warehouseList)}}</span> -->
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.search_outwarehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                        :rules="required"
                        prop="orgWarehouseCode"
                    >
                        <Select
                            v-model="formData.orgWarehouseCode"
                            filterable
                            clearable
                            @on-change="getShipping"
                        >
                            <Option value="0">System Auto</Option>
                            <Option
                                v-for="item in getWarehouseList"
                                :value="item.attach.code"
                                :key="item.id"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.shippingservice_level', {
                                defaultValue: '发货服务等级',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.shipServiceLevel || "--"
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12" style="height: 32px">
                    <FormItem
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        v-if="alltype == 'query'"
                    >
                        <span class="font-weight">{{
                            comLogistics.shippingMethodCode || "--"
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        :rules="required"
                        prop="shippingMethodCode"
                    >
                        <vSelect
                            v-model="formData.shippingMethodCode"
                            filterable
                            clearable
                            ref="refshipping"
                            :loading="loading"
                        >
                            <vOption value="AUTO">System Auto</vOption>
                            <vOption
                                v-for="item in shippingList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                        <!-- <Select v-model="formData.carrierAccountGroupId"
                placeholder="请选择承运商"
                filterable
                clearable
                ref="refshipping"
                :loading="loading"
                style="width:50%;float:left">
          <Option v-for="item in getCarrierCusList"
                  :value="item.value"
                  :key="item.value">{{ item.label }}</Option>
        </Select> -->
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.latest_time', {
                                defaultValue: '最晚发货时间',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.latestShipDate || "--"
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12" style="height: 42px" v-if="this.b2cOrderAccount">
                    <FormItem
                        :label="
                            $t('erp.b2c.3rd_account', {
                                defaultValue: '3rd账号',
                            })
                        "
                        v-if="alltype == 'query'"
                    >
                        <span class="font-weight margin-right-10">{{
                            comLogistics.chargeAccountNo || "--"
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.3rd_account', {
                                defaultValue: '3rd账号',
                            })
                        "
                    >
                        <Input v-model="formData.chargeAccountNo"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.channel_delivery', {
                                defaultValue: '渠道发货方式',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.channelMethodCode || "--"
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12" style="height: 42px">
                    <FormItem
                        v-if="alltype == 'query'"
                        :label="
                            $t('erp.b2c.whether_insured', {
                                defaultValue: '是否投保',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.isInsurance == "Y"
                                ? $t("erp.global.yes", { defaultValue: "是" })
                                : $t("erp.global.no", { defaultValue: "否" })
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.whether_insured', {
                                defaultValue: '是否投保',
                            })
                        "
                    >
                        <div>
                            <RadioGroup
                                v-model="comLogistics.isInsurance"
                                @on-change="
                                    changeIsInsurance(comLogistics.isInsurance)
                                "
                            >
                                <Radio label="Y">
                                    <Icon type="social-yes"></Icon>
                                    <span>{{
                                        $t("erp.global.yes", {
                                            defaultValue: "是",
                                        })
                                    }}</span>
                                </Radio>
                                <Radio label="N">
                                    <Icon type="social-no"></Icon>
                                    <span>{{
                                        $t("erp.global.no", {
                                            defaultValue: "否",
                                        })
                                    }}</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.channel_warehouse', {
                                defaultValue: '渠道仓库',
                            })
                        "
                    >
                        <span class="font-weight"
                            >{{ comLogistics.channelWarehouseCode || "--" }}
                        </span>
                    </FormItem>
                </Col>
                <Col span="12" style="height: 42px">
                    <FormItem
                        v-if="alltype == 'query'"
                        :label="
                            $t('erp.b2c.is_signfor', {
                                defaultValue: '是否需要签收',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.isSign == "1"
                                ? $t("erp.global.yes", { defaultValue: "是" })
                                : $t("erp.global.no", { defaultValue: "否" })
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.is_signfor', {
                                defaultValue: '是否需要签收',
                            })
                        "
                    >
                        <div>
                            <RadioGroup v-model="comLogistics.isSign">
                                <Radio label="1">
                                    <Icon type="social-yes"></Icon>
                                    <span>{{
                                        $t("erp.global.yes", {
                                            defaultValue: "是",
                                        })
                                    }}</span>
                                </Radio>
                                <Radio label="0">
                                    <Icon type="social-no"></Icon>
                                    <span>{{
                                        $t("erp.global.no", {
                                            defaultValue: "否",
                                        })
                                    }}</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12" v-if="alltype == 'query'">
                    <FormItem
                        :label="
                            $t('erp.b2c.product_weight', {
                                defaultValue: '产品重量',
                            })
                        "
                    >
                        <span class="font-weight"
                            >{{ comLogistics.weight }} g /
                            {{ (comLogistics.weight * 0.035274).toFixed(2) }} oz
                        </span>
                    </FormItem>
                </Col>
                <Col span="12" v-if="alltype == 'query'">
                    <FormItem
                        :label="
                            $t('erp.b2c.estimate_costs', {
                                defaultValue: '预估物流费',
                            })
                        "
                    >
                        <div>
                            <span class="font-weight"
                                >{{ comLogistics.shippingfee }} USD</span
                            >
                            <Tooltip
                                :content="
                                    (isShow
                                        ? $t('erp.b2c.retract', {
                                              defaultValue: '收起',
                                          })
                                        : $t('tms.ship.expand', {
                                              defaultValue: '展开',
                                          })) +
                                    $t('tms.ship.cost_details', {
                                        defaultValue: '费用明细',
                                    })
                                "
                                placement="top"
                            >
                                <Icon
                                    class="margin-left-10"
                                    type="ios-paper-outline"
                                    style="font-size: x-large"
                                    @click="isShow = !isShow"
                                ></Icon>
                            </Tooltip>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12" v-if="alltype == 'query'">
                    <FormItem
                        :label="
                            $t('erp.b2c.expect_send_time', {
                                defaultValue: '仓库预计发货时间',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            comLogistics.warehouseExpectedShipDate || "--"
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12" v-if="SYSID == 1000147">
                    <FormItem label="pickupTime">
                        <span class="font-weight">{{
                            comLogistics.latestShipDate
                                ? comLogistics.earliestShipDate +
                                  " ~ " +
                                  comLogistics.latestShipDate
                                : "--"
                        }}</span>
                    </FormItem>
                </Col>
            </Col>
        </Form>
        <div class="logistics-cost-detail padding-bottom-15" v-show="isShow">
            <Table
                class="margin-15"
                size="small"
                show-summary
                :summary-method="handleTotal"
                style="overflow: hidden; height: initial"
                border
                :data="costData"
                :columns="costColumn"
            ></Table>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpProductErpSku } from "@/service/boss/dictionary";
import {
    HttpGetOrgWarehouseCode,
    HttpGetCarrierCusList,
    HttpGetCalculateCost,
} from "@/service/boss/b2corder";
export default {
    props: ["comLogistics", "alltype", "status", "parentId"],
    data() {
        return {
            SYSID: global.SYSID,
            formData: {
                orgWarehouseCode: "0",
                shippingMethodCode: "AUTO",
                chargeAccountNo: "",
                isInsurance: "N",
                isSign: "",
                // warehouseId:'0',
                b2cOrderAccount: false,
            },
            loading: false,
            shippingList: [],
            required: [
                {
                    required: true,
                    message: this.$t("global.common.fill_requiredd", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            costData: [],
            disableChargeAccNo: false,
            disableCarrier: false,
            isShow: false,
        };
    },
    created() {
        this.b2cOrderAccount = this.handleAuth("erp.b2cOrder.account");
        if (this.alltype != "query") {
            this.handleDatas();
        }
        if (this.alltype == "query") {
            this.getCalData();
        }
    },
    updated() {
        this.changeIsInsurance(this.comLogistics.isInsurance);
    },
    computed: {
        ...mapState("boss", ["warehouseList"]),
        ...mapGetters("dictionary", ["getWarehouseList", "getCarrierCusList"]),
        costColumn() {
            return [
                {
                    type: "expand",
                    width: 100,
                    align: "center",
                    render: (h, { row }) => {
                        return (
                            <Table
                                border
                                size="small"
                                data={row.items}
                                columns={this.childColumn}
                            ></Table>
                        );
                    },
                },
                {
                    title: this.$t("erp.b2c.shipping_order_number", {
                        defaultValue: "发货单号",
                    }),
                    key: "deliver_no",
                },
                {
                    title: "ERPSKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "shipping_method_code",
                },
                {
                    title: this.$t("tms.ship.estimated_cost", {
                        defaultValue: "预估费用",
                    }),
                    key: "local_total",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.local_total} {row.items[0].currency}
                            </div>
                        );
                    },
                },
            ];
        },
        childColumn() {
            return [
                {
                    title: this.$t("global.common.name", {
                        defaultValue: "名称",
                    }),
                    key: "costName",
                },
                {
                    title: this.$t("erp.b2c.cost", {
                        defaultValue: "费用",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.estimatedCost} {row.currency}
                            </div>
                        );
                    },
                },
            ];
        },
    },
    methods: {
        async getCalData() {
            await HttpGetCalculateCost({
                orderId: this.parentId,
            }).then(
                (res) => {
                    this.costData = res.data.map((item) => {
                        let local_total =
                            Math.round(item.local_total * 100) / 100;
                        return {
                            ...item,
                            local_total: local_total,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleTotal({ columns, data }) {
            const sums = {};
            let total = 0;
            data.map((item) => {
                total = parseFloat(total);
                total += parseFloat(item.local_total);
            });
            total = Math.round(total * 100) / 100;
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: this.$t("erp.b2c.total_price", {
                            defaultValue: "总价",
                        }),
                    };
                    return;
                } else if (key == "local_total") {
                    sums[key] = {
                        key,
                        value: `${total} ${data[0].items[0].currency}`,
                    };
                } else {
                    sums[key] = {
                        key,
                        value: null,
                    };
                }
            });

            return sums;
        },
        changeIsInsurance(val) {
            let value = false;
            if (val === "Y") value = true;
            this.$emit("isInsuranceChange", value);
        },
        handleDatas() {
            if (this.comLogistics.orgWarehouseCode) {
                let {
                    orgWarehouseCode,
                    shippingMethodCode,
                    chargeAccountNo,
                    isInsurance,
                    isSign,
                    carrierAccountGroupId,
                } = this.comLogistics;
                this.formData = {
                    orgWarehouseCode,
                    shippingMethodCode,
                    chargeAccountNo,
                    isInsurance,
                    isSign,
                    carrierAccountGroupId,
                };
                if (this.formData.shippingMethodCode == "") {
                    this.formData.shippingMethodCode = "AUTO";
                } else {
                    let json = {
                        value: shippingMethodCode,
                        label: shippingMethodCode,
                    };
                    this.shippingList.push(json);
                    this.formData.shippingMethodCode = shippingMethodCode;
                    this.loading = true;
                }
                this.getwarehouseCarry(this.formData.orgWarehouseCode);
            } else {
                let {
                    orgWarehouseCode,
                    shippingMethodCode,
                    chargeAccountNo,
                    isInsurance,
                    isSign,
                    carrierAccountGroupId,
                } = this.comLogistics;
                this.formData = {
                    chargeAccountNo,
                    isInsurance,
                    isSign,
                    carrierAccountGroupId,
                };
                this.formData.orgWarehouseCode = "0";
                // this.formData.chargeAccount
                // No = ''
                // this.formData.isInsurance = 'N'
                // this.formData.isSign = ''
                if (shippingMethodCode) {
                    let aaa = [
                        {
                            label: shippingMethodCode,
                            value: shippingMethodCode,
                        },
                        // {carrierServiceCode:'WLC'},
                        { label: "YRC", value: "YRC" },
                        { label: "Australia Post", value: "Australia Post" },
                        { label: "Other", value: "Other" },
                    ];
                    this.shippingList = aaa;
                    this.formData.shippingMethodCode = shippingMethodCode;
                } else {
                    this.formData.shippingMethodCode = "AUTO";
                }
            }
            // 判断是否disable
            if (this.formData.carrierAccountGroupId) {
                this.disableChargeAccNo = true;
            } else {
                this.disableChargeAccNo = false;
            }
            if (this.formData.chargeAccountNo) {
                this.disableCarrier = true;
            } else {
                this.disableCarrier = false;
            }
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        getShipping() {
            // console.log(this.formData.orgWarehouseCode)
            this.formData.shippingMethodCode = "";
            // this.$refs.refshipping.clearSingleSelect()
            this.loading = true;
            if (this.formData.orgWarehouseCode != "0") {
                this.getwarehouseCarry(this.formData.orgWarehouseCode);
            } else {
                let aaa = [
                    // {carrierServiceCode:'WLC'},
                    { label: "YRC", value: "YRC" },
                    { label: "Australia Post", value: "Australia Post" },
                    { label: "Other", value: "Other" },
                ];
                this.loading = false;
                this.shippingList = aaa;
            }
        },
        getwarehouseCarry(value) {
            HttpGetOrgWarehouseCode({
                orgId: global.SYSID,
                warehouseCode: value,
            })
                .then(
                    (res) => {
                        let aaa = [
                            // {carrierServiceCode:'WLC'},
                            { label: "YRC", value: "YRC" },
                            {
                                label: "Australia Post",
                                value: "Australia Post",
                            },
                            { label: "Other", value: "Other" },
                        ];
                        let dataArr = [];
                        if (res.data) {
                            dataArr = res.data.map((item) => {
                                return {
                                    label: `${item.code}(${item.carrierServiceName})`,
                                    value: item.code,
                                    attach: {
                                        ...item,
                                    },
                                };
                            });
                        }
                        this.shippingList = dataArr;
                        this.shippingList = this.shippingList.concat(aaa);
                        this.shippingList = this.arrayUnique(
                            this.shippingList,
                            "value"
                        );

                        // console.log(res)
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally((result) => {
                    this.loading = false;
                });
        },
    },
    watch: {
        "comLogistics.isInsurance": function () {
            this.formData.isInsurance = this.comLogistics.isInsurance;
        },
        "comLogistics.isSign": function () {
            this.formData.isSign = this.comLogistics.isSign;
        },
        comLogistics() {
            if (this.alltype != "query") {
                this.handleDatas();
            }
        },
    },
};
</script>
